import React, { useRef, useState } from "react";
import styled from 'styled-components';
import { AgCharts } from "ag-charts-react";

const GraphWrapper = styled.div`
    padding-top: 10px;
    padding-left: 10px;
    padding-right: 10px;
    overflow: auto;
    width: 800px;
    max-height: 600px;
    height: 600px;
    min-height: 600px !important;
    overflow-y: auto;

    .ag-charts-wrapper {
        height: 600px !important;
    }

 `;

const Chart = (props) => {

  const [options, setOptions] = useState({data: [], series: [], axes: [{}]});

    React.useEffect(() => {
        setOptions({
          data: props.seriesData, 
          series: props.categoryData,
          axes: [
            {
              type: "category",
              label: {
                enabled: true,
              },
            },
          ]
        })
    }, [props]);

    return(
        <GraphWrapper>
            <AgCharts options={options} />
        </GraphWrapper>
    );
}

export default Chart;

/*

        axes: [ 
            {
              type: 'category',
              label: {
                fontSize: 10,
              },
            },
        ]
*/